import React from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'

import { login } from './services'
import { handleError } from '../../helpers'
import { userLogin } from './actions'

export default function Login() {
	const { handleSubmit, register, formState: { errors } } = useForm()
	const dispatch = useDispatch()

	const onSubmit = values => {
		login(values)
			.then(res => {
				dispatch(userLogin(res.data))
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<h5 className="mb-10">Iniciar Sesión</h5>
			<p className="text-muted mb-20">Bienvenido de nuevo. Ingrese su cédula y contraseña para ingresar al administrador del CEN Financiero Spring.</p>
			<Form className="text-left" onSubmit={handleSubmit(onSubmit)}>
				<Form.Group className='form-group'>
					<Form.Label>Ingresar como:</Form.Label>
					<Form.Control
						as="select"
						{...register('role', { required: true })}
					>
						<option value="agent">Asesor Virtual</option>
						<option value="admin">Administrador</option>
					</Form.Control>
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Número de Cédula <span className="text-primary">*</span></Form.Label>
					<Form.Control 
						type="number"
						placeholder="Escriba su documento"
						{...register('document', { required: true })}
					/>
					{ errors.document && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Contraseña <span className="text-primary">*</span></Form.Label>
					<Form.Control
						type="password"
						placeholder="Escriba su contraseña"
						{...register('password', { required: true })}
					/>
					{ errors.password && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Button color="primary" className="full-width">Iniciar Sesión</Button>
			</Form>
		</React.Fragment>
	)
}